<div #parent>
  <optsol-ngx-data-import-2 [config]="data.config" [tableHeight]="tableHeight" (submissionResponse)="submitted($event)"
    (matStepperSelectionChange)="matStepperSelectionChange($event)" (close)="closeDialog()"></optsol-ngx-data-import-2>
</div>